import React from 'react';
import styles from './Service.module.scss'
import ServiceCallsTable from "../../../components/ServiceCallsTable/ServiceCallsTable";
import {$t} from "../../../helpers/translator";
import ErrorsTable from "../../../components/ErrorsTable/ErrorsTable";
import ErrorsGraph from "../../../components/ErrorsGraph/ErrorsGraph";


const DistributorService = () => {
    return (
        <div className={styles.container}>
            <div id='serviceCallsTable' className={styles['flex-row']}>
                <div className={styles['box']}>
                    <ServiceCallsTable userType={4} header={$t('global.service.ServiceCalls')}/>
                </div>
            </div>

            <div id='serviceErrorsTable' className={styles['flex-row']}>
                <div className={styles['box']}>
                    <ErrorsTable userType={4} header={$t('global.service.platformErrors')}/>
                </div>
            </div>

            <div id='serviceErrorsGraph' className={styles['flex-row']}>
                <div className={styles['box']}>
                    <ErrorsGraph userType={4} header={$t('global.service.platformErrorsGraph')}/>
                </div>
            </div>
        </div>
    )
}

export default DistributorService;
